import ResetApplicationRoute from './ResetApplicationRoute';
export * from './ResetApplicationRoute';
export default ResetApplicationRoute;
